/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
function ic_wait_for_qualified_js() {
  if ( typeof qualified !== 'undefined' ) {
    //chat events 
    qualified( 'handleMessengerEvents', function ( eventName ) {
      if ( eventName == 'messengerOpened' ) {
        window.dataLayer.push( { 'event': 'chat_start' } );
      }
      else if ( eventName == 'messengerClosed' ) {
        window.dataLayer.push( { 'event': 'chat_close', 'chat_type': '' } );
      }


      qualified( 'handleEvents', function ( name, data ) {
        switch ( name ) {

        case 'Email Captured':
          window.dataLayer.push( {
            'event': 'chat_interactions', 'chat_type': '', 'interaction_type': 'email captured'
          } );
          break;
        case 'Meeting Booked':
          dataLayer.push( {
            'event': 'chat_interactions', 'chat_type': '', 'interaction_type': 'meeting booked'
          } );
          break;
        }
      } );

    } );
  }
  else {
    setTimeout( ic_wait_for_qualified_js, 1000 );
  }
}

ic_wait_for_qualified_js();